<ng-container *ngIf="log?.remarkLink; else noRemarksLink">
  <a
    [ngClass]="{
      'text-primary': log?.isClickableRemarks,
    }"
    [href]="log?.remarkLink"
    target="_blank"
  >
    {{ log.remarks }}
  </a>
</ng-container>
<ng-template #noRemarksLink>
  <span> {{ log.remarks }}</span>
</ng-template>
